import { ComponentsOverrides, Theme } from "@mui/material";
import { InternalThemeConfig } from "../../config";

const tableCell = ({ spacing }: InternalThemeConfig): ComponentsOverrides<Theme>["MuiTableCell"] => ({
	root: {
		borderBottom: "none",
	},
	head: {
		lineHeight: spacing(3),
		verticalAlign: "bottom",
	},
});

export default tableCell;
